import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "modal-box" }
const _hoisted_2 = { class: "top-nav" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]

import { ref, computed } from 'vue';
import Popup from '@/components/Popup/Index.vue';
import { originObj } from '@/config/index';


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: /*@__PURE__*/_mergeModels({
    selfRouter: {
        type: Object,
        default: () => ({
            pageList: [],
            lastonePage: '',
            backFn: () => null
        })
    }
}, {
    "modelValue": {
    default: false
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {



const props: any = __props

const selfRouter = computed(() => props.selfRouter || {})

const show = _useModel(__props, "modelValue")
const close = () => {
    show.value = false
}






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Popup, {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
      type: "center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              (selfRouter.value?.pageList?.length > 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "icon",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (selfRouter.value?.backFn && selfRouter.value?.backFn(...args))),
                    src: require('@/assets/img/login/back.png'),
                    alt: ""
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("img", {
              class: "logo",
              src: _unref(originObj)?.logo?.modal || '',
              alt: ""
            }, null, 8, _hoisted_5),
            _createElementVNode("img", {
              class: "icon",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (close())),
              src: require('@/assets/img/login/close.png'),
              alt: ""
            }, null, 8, _hoisted_6)
          ]),
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["modelValue"])
  ]))
}
}

})